import React from 'react';
import { Quote } from 'lucide-react';
import { LANDING } from '@/constants/testIds';

const testimonials = [
    {
        quote:
            "Finally an app that doesn't feel bloated. Every screen earns its place — and the analytics are exactly what I've been missing.",
        author: 'Alex T.',
        role: 'Powerlifter · 4 yrs training',
    },
    {
        quote:
            'The analytics breakdown by muscle group helped me fix imbalances I never knew I had. My back lifts shot up within a month.',
        author: 'Sarah M.',
        role: 'Hybrid athlete',
    },
    {
        quote:
            "It tracks everything I care about in one place — workouts, measurements, body weight. I dropped three other apps after a week.",
        author: 'Marcus D.',
        role: 'Bodybuilding prep',
    },
];

export const Testimonials = () => {
    return (
        <section
            id="testimonials"
            data-testid={LANDING.testimonialsSection}
            className="relative py-28 sm:py-36"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs uppercase tracking-[0.25em] text-[#b8ff00] font-semibold mb-4">
                        — Loved by lifters
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.02]">
                        Built for people
                        <br />
                        who actually train.
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-5">
                    {testimonials.map((t, i) => (
                        <article
                            key={t.author}
                            data-testid={LANDING.testimonial(i + 1)}
                            className="surface-card p-7 flex flex-col"
                        >
                            <Quote
                                className="w-7 h-7 text-[#b8ff00] mb-5"
                                strokeWidth={2}
                            />
                            <p className="text-white text-base leading-relaxed mb-6 flex-1">
                                &ldquo;{t.quote}&rdquo;
                            </p>
                            <div className="border-t border-white/5 pt-4">
                                <div className="text-white text-sm font-semibold">
                                    {t.author}
                                </div>
                                <div className="text-[#8e8e93] text-xs mt-0.5">
                                    {t.role}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
